import { useState, useCallback, useEffect } from 'react';
import { API_ENDPOINTS } from './src-config-api-config.js';
import { TENANT, CB_GCP_API_KEY } from './src-config-app-config.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const useGCPChat = (locale) => {
  const { logCustomAttributesNR } = useNRLogging();
  const feature = "ContactUsPage";
  const REQUEST_URL = `${API_ENDPOINTS.GCP}/v3/channels/chat?tenant=${TENANT}&locale=${locale}&feature=${feature}`;
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [toggle, setToggle] = useState(false);
  const trigger = useCallback(() => {
    setToggle(true);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (toggle) {
        setLoading(true);
        try {
          logCustomAttributesNR("ca-chatbot-misc-api-request", {
            requestUrl: REQUEST_URL,
            feature,
            tenant: TENANT,
            locale,
            logLevel: "info",
            message: "Fetching GCP Chat API data",
            apiType: "getGCPData"
          });
          const response = await fetch(REQUEST_URL, {
            headers: {
              "x-api-key": CB_GCP_API_KEY
            }
          });
          if (!response.ok) {
            const error2 = new Error(`API responded with status: ${response.status}`);
            error2.name = "ApiError";
            throw error2;
          }
          const responseData = await response.json();
          setData(responseData);
        } catch (error2) {
          console.error(error2);
          setError(new Error());
          logCustomAttributesNR("ca-chatbot-misc-api-error", {
            errorName: error2?.name,
            errorStack: error2?.stack,
            message: error2?.message,
            logLevel: "error",
            apiType: "getGCPData"
          });
          setData(void 0);
        } finally {
          setLoading(false);
          setToggle(false);
        }
      }
    };
    fetchData();
  }, [locale, toggle]);
  return { data, loading, error, trigger };
};

export { useGCPChat };
//# sourceMappingURL=src-hooks-utility-hooks-useGCPChat.js.map
